@if (multiple) {
  <p-autoComplete
    #autoComplete
    [(ngModel)]="_arrayValue"
    (ngModelChange)="changeValue($event)"
    [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
    [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
    [disabled]="disabled"
    [inputStyle]="inputStyle"
    [inputStyleClass]="inputStyleClass"
    [panelStyleClass]="mergedPanelStyleClass"
    [suggestions]="suggestions"
    [virtualScroll]="virtualScroll"
    [virtualScrollItemSize]="virtualScrollItemSize"
    [scrollHeight]="resolvedScrollHeight"
    [dataKey]="optionValue"
    [appendTo]="appendTo ?? 'body'"
    [placeholder]="placeholder"
    [multiple]="multiple"
    [dropdown]="dropdown"
    [optionLabel]="optionLabel"
    [optionValue]="optionValue"
    (completeMethod)="completeMethod.emit($event)">
    @if (headerTemplate) {
      <ng-template pTemplate="header">
        <ng-template [ngTemplateOutlet]="headerTemplate"></ng-template>
      </ng-template>
    }

    @if (groupTemplate) {
      <ng-template
        pTemplate="group"
        let-item>
        <ng-template
          [ngTemplateOutlet]="groupTemplate"
          [ngTemplateOutletContext]="{ item: item }"></ng-template>
      </ng-template>
    }

    @if (selectedItemTemplate) {
      <ng-template
        pTemplate="selectedItem"
        let-item>
        <ng-template
          [ngTemplateOutlet]="selectedItemTemplate"
          [ngTemplateOutletContext]="{ item: item }"></ng-template>
      </ng-template>
    }

    @if (itemTemplate) {
      <ng-template
        pTemplate="item"
        let-item
        let-index="index">
        <ng-template
          [ngTemplateOutlet]="itemTemplate"
          [ngTemplateOutletContext]="{ item: item, index: index }"></ng-template>
      </ng-template>
    } @else {
      <ng-template
        pTemplate="item"
        let-item>
        <span [innerHTML]="highlightMatchText(item | nestedProperty: optionLabel)"></span>
      </ng-template>
    }

    @if (footerTemplate) {
      <ng-template pTemplate="footer">
        <ng-template [ngTemplateOutlet]="footerTemplate"></ng-template>
      </ng-template>
    }
  </p-autoComplete>
  @if (loading) {
    <i
      class="pi pi-spin pi-spinner frm-autocomplete-loading-icon"
      [class.frm-autocomplete-loading-icon--with-dropdown]="dropdown"
      aria-hidden="true"></i>
  }
} @else {
  <p-autoComplete
    #autoComplete
    [(ngModel)]="_value"
    (ngModelChange)="changeValue($event)"
    [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
    [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
    [disabled]="disabled"
    [inputStyle]="inputStyle"
    [inputStyleClass]="inputStyleClass"
    [panelStyleClass]="mergedPanelStyleClass"
    [suggestions]="suggestions"
    [virtualScroll]="virtualScroll"
    [virtualScrollItemSize]="virtualScrollItemSize"
    [scrollHeight]="resolvedScrollHeight"
    [dataKey]="optionValue"
    [appendTo]="appendTo ?? 'body'"
    [placeholder]="placeholder"
    [showClear]="showClear && !loading"
    [multiple]="multiple"
    [dropdown]="dropdown"
    [autofocus]="autofocus"
    [optionLabel]="optionLabel"
    (onSelect)="onSelect($event)"
    (completeMethod)="completeMethod.emit($event)"
    (onBlur)="onBlur()"
    (onClear)="onClear()">
    @if (headerTemplate) {
      <ng-template pTemplate="header">
        <ng-template [ngTemplateOutlet]="headerTemplate"></ng-template>
      </ng-template>
    }

    @if (groupTemplate) {
      <ng-template
        pTemplate="group"
        let-item>
        <ng-template
          [ngTemplateOutlet]="groupTemplate"
          [ngTemplateOutletContext]="{ item: item }"></ng-template>
      </ng-template>
    }

    @if (selectedItemTemplate) {
      <ng-template
        pTemplate="selectedItem"
        let-item>
        <ng-template
          [ngTemplateOutlet]="selectedItemTemplate"
          [ngTemplateOutletContext]="{ item: item }"></ng-template>
      </ng-template>
    }

    @if (itemTemplate) {
      <ng-template
        pTemplate="item"
        let-item
        let-index="index">
        <ng-template
          [ngTemplateOutlet]="itemTemplate"
          [ngTemplateOutletContext]="{ item: item, index: index }"></ng-template>
      </ng-template>
    } @else {
      <ng-template
        pTemplate="item"
        let-item>
        <span [innerHTML]="highlightMatchText(item | nestedProperty: optionLabel)"></span>
      </ng-template>
    }

    @if (footerTemplate) {
      <ng-template pTemplate="footer">
        <ng-template [ngTemplateOutlet]="footerTemplate"></ng-template>
      </ng-template>
    }
  </p-autoComplete>
  @if (loading) {
    <i
      class="pi pi-spin pi-spinner frm-autocomplete-loading-icon"
      [class.frm-autocomplete-loading-icon--with-dropdown]="dropdown"
      aria-hidden="true"></i>
  }
}
